import { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import FileUploader from '../FileUploader.js/FileUploader';
import InfoHubCategoryDropdown from '../InfoHubCategoryDropdown/InfoHubCategoryDropdown';
import EmployeeVisibilityDropdown from '../VisibilityDropdown/EmployeeVisibilityDropdown';
import { EntityList } from '../VisibilityDropdown/EntityList';
import EntityVisibilityDropdown from '../VisibilityDropdown/EntityVisibilityDropdown';
import './AddModal.css';

const EditFileModal = ({ handleClose, show, modalInfo, onEdit }) => {
    const [fileID, setFileID] = useState('');
    const [categoryID, setCategoryID] = useState('');
    const [fileName, setFileName] = useState('');
    const [fileLink, setFileLink] = useState('');
    const [fileType, setFileType] = useState('');
    const [fileSize, setFileSize] = useState('');
    const [employee, setEmployee] = useState('');
    const [modifiedBy, setModifiedBy] = useState('');

    const [selectedEntity, setSelectedEntity] = useState([]);

    const options = EntityList;

    useEffect(() => {
        setFileID(modalInfo.fileID);
        setCategoryID(modalInfo.categoryID);
        setFileName(modalInfo.fileName);
        setFileLink(modalInfo.fileLink);
        setFileType(modalInfo.fileType);
        setFileSize(modalInfo.fileSize);
        setEmployee(modalInfo.fileEmployee);
        setModifiedBy(localStorage.getItem('badgeID'));

        const item = modalInfo;

        if (Object.keys(item).length !== 0) {
            if (item.fileEntity.indexOf(',') > -1) {
                let array = item.fileEntity.split(',');
                let newArray = array.map((item) => ({
                    value: item,
                    label: item,
                }));
                setSelectedEntity(newArray);
            } else {
                let array = [
                    { value: item.fileEntity, label: item.fileEntity },
                ];
                setSelectedEntity(array);
            }
        }
    }, [modalInfo]);

    const getCategoryID = (categoryIDProp) => {
        setCategoryID(categoryIDProp);
    };

    const getEmployeeVisibility = (employeeVisibilityProp) => {
        let newEmployee = employeeVisibilityProp.toString();
        setEmployee(newEmployee);
    };

    const getFileInfo = (
        fileNameProp,
        fileLinkProp,
        fileTypeProp,
        fileSizeProp
    ) => {
        setFileName(fileNameProp);
        setFileLink(fileLinkProp);
        setFileType(fileTypeProp);
        setFileSize(fileSizeProp);
    };

    const onSubmit = (e) => {
        e.preventDefault();

        if (!categoryID) {
            alert('Please select a category name');
        } else if (!fileName || !fileLink || !fileSize) {
            alert('Please upload a file first');
        } else if (!employee) {
            alert('Please select an employee type');
        } else if (selectedEntity.length === 0) {
            alert('Please select an entity type');
        } else {
            const entity = selectedEntity.map((x) => x.value).toString();

            onEdit({
                fileID,
                categoryID,
                fileName,
                fileLink,
                fileType,
                fileSize,
                employee,
                entity,
                modifiedBy,
            });
        }
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header>
                <Modal.Title style={{ marginBottom: '0px' }}>
                    Edit File
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={onSubmit}>
                    <Form.Group className='mb-3'>
                        <Form.Label>Folder Name</Form.Label>
                        <InfoHubCategoryDropdown
                            getCategoryID={getCategoryID}
                            categoryID={modalInfo.categoryID}
                            categoryName={modalInfo.categoryName}
                        />
                    </Form.Group>
                    <Form.Group className='mb-3'>
                        <Form.Label>Upload File</Form.Label>
                        <FileUploader
                            getFileInfo={getFileInfo}
                            fileLink={fileLink}
                        />
                    </Form.Group>
                    <Form.Group className='mb-3'>
                        <Form.Label>Visible To</Form.Label>
                        <EmployeeVisibilityDropdown
                            getEmployeeVisibility={getEmployeeVisibility}
                            employee={employee}
                        />
                        <EntityVisibilityDropdown
                            options={options}
                            value={selectedEntity}
                            onChange={setSelectedEntity}
                        />
                    </Form.Group>
                    <Button as='input' type='submit' value='Submit' />
                    <Button variant='outline-secondary' onClick={handleClose}>
                        Close
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default EditFileModal;
